import axios from '../utilities/axios'

const FAQ_USER_PATH = 'amd_faq_user_path'
export const FAQ_PENDING_PATH = 'amd_faq_pending_path'

function findFaqById(faqs, faqId) {
  if (!Array.isArray(faqs)) return null
  return faqs.find(item => item.faqId === parseInt(faqId, 10)) || null
}

async function getFaqs(query = '') {
  const url = `/api/v1/faq/${query && `?q=${query}`}`
  return axios.get(url)
}

async function getRelatedFaq(query) {
  const url = `/api/v1/faq/${query}`
  return axios.get(url)
}

async function getFaqsWithTagCloud(query = '') {
  const url = `/api/v1/faq/faqTagCloud/${query && `?tagCloudId=${query}`}`
  return axios.get(url)
}

async function getFaqsCategories() {
  const url = '/api/v1/faq/category/'
  return axios.get(url)
}

async function getFaqTagCloud() {
  const url = '/api/v1/faq/tagCloud/'
  return axios.get(url)
}

async function postFaqScore(payload) {
  const url = '/api/v1/faq/score'
  return axios.post(url, { payload })
}

async function saveFaqLog(payload) {
  const url = '/api/v1/faq/log'
  return axios.post(url, { payload })
}

function saveUserFaqHistory(payload) {
  return localStorage.setItem(FAQ_USER_PATH, payload)
}

function getUserFaqHistory() {
  const ticket = localStorage.getItem(FAQ_USER_PATH)
  return JSON.parse(ticket) || null
}

function removeUserFaqHistory() {
  return localStorage.removeItem(FAQ_USER_PATH)
}

function saveFaqScoreFeedback(payload) {
  const url = '/api/v1/faq/score/feedback/'
  return axios.post(url, { payload })
}

export default {
  findFaqById,
  getFaqs,
  getFaqsWithTagCloud,
  getRelatedFaq,
  getFaqsCategories,
  getFaqTagCloud,
  postFaqScore,
  saveUserFaqHistory,
  saveFaqScoreFeedback,
  saveFaqLog,
  getUserFaqHistory,
  removeUserFaqHistory,
}
